
import cartType from "../../actions/cart/cartType";

const initialState = {
 loading:true,
 error:false,
 errorMessage:'',
isCompany:false,
isPersonal:false,
companyDetail:[],
cart:[]

}

const cartReducer=( state = initialState, action) => {


switch(action.type) {

case  cartType.START_FETCHING_CART_DETAILS :
    return{
        ...state,
        loading:true,
        isCompany:false,
        isPersonal:false,
        cart:[]
    }
case  cartType.SET_CART_DETAILS :
    return{
        ...state,
        cart:action.payload,
        loading:false,
        error:false,
        isCompany:false,
        isPersonal:false,

    }
case  cartType.FAILED_FETCHIED_CART_DETAILS :
    return{
        ...state,
        cart:[],
        errorMessage:action.payload,
        error:true,
        loading:false,
        isCompany:false,
        isPersonal:false,
        

    }
case cartType.SET_IS_COMPANY:
    return{
        ...state,
        isCompany:true,
        isPersonal:false
    }
case cartType.SET_IS_PERSONAL:
    return{
        ...state,
        isCompany:false,
        isPersonal:true
    }
case cartType.SET_COMPANY_DETAILS:
    return{
        ...state,
companyDetail:action.payload
    }



    default: return state;
}

}


export default cartReducer